module.exports = __webpack_public_path__ + "static/media/busy.e4b70257.svg";